import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import { API } from '@const'
import * as utils from '@utils'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
import Divider from '@material-ui/core/Divider'
import { Button, Select, MenuItem, FormControl, InputLabel, TextField, Grid, FormLabel, FormControlLabel, Radio } from '@material-ui/core'
import { PfSubPfSelect, DatetimeSelect } from '@select'
import { TreeSelect } from 'antd'
import moment from 'moment'
import { addToast } from '../../utils/toast'

const initialState = {
    title: '',
    dialogOpen: false,
    name: '',
    is_active: 'active',
    imageData: {
        CHS: null,
        ENU: null,
        VIE: null,
        THA: null,
        ESP: null,
        PTE: null,
    },
    pf_id: '',
    pfSubPfIDList: [],
    pfSubTree: [],
    imgType: 'bannerImg',
    is_custom: false,
    start_at: '',
    end_at: '',
    typeRole: {
        bannerImg: {
            width: 651,
            height: 364,
            size: 400,
            format: ['jpeg', 'png'],
        },
        iconImg: {
            width: 128,
            height: 128,
            size: 20,
            format: ['png'],
        },
    },
}

class AddActivityImageDialog extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key) => {
            return utils.t(key, 'ActivityImageDialog')
        }
        this.state = initialState
    }

    reset() {
        this.setState({ ...initialState })
    }

    componentDidMount() {
        this.props.onRef(this)
    }

    componentWillUnmount() {
        this.props.onRef(undefined)
    }

    OpenDialog(inputs) {
        this.reset()
        this.setState(
            {
                dialogOpen: true,
                title: inputs.title,
                pf_id: inputs.pf_id,
            },
            () => {
                this.setSelectPf()
            }
        )
    }

    async setSelectPf() {
        await this.handlePfTreeData()
        if (this.state.is_custom) {
            this.pfSubPfSelect.setState({
                pfId: this.state.pf_id,
            })
        }
    }

    handlePfTreeData = async () => {
        const pfSubTree = utils.generatePfTreeData().filter((item) => item.key === this.state.pf_id)
        const pfSubPfIDList = pfSubTree.reduce((result, item) => {
            item.children.forEach((child) => {
                result.push(child.value)
            })
            return result
        }, [])

        this.setState({
            pfSubTree,
            pfSubPfIDList,
        })
    }

    closeDialog() {
        this.setState({ dialogOpen: false })
    }

    verifyData() {
        const verifyRule = {
            noNameEnter: this.state.name.length === 0,
            noCustomCurrencySelect: this.pfSubPfSelect?.state.pfId.length === 0,
            noCustomPlatformSelect: this.state.pfSubPfIDList?.length === 0,
            endAtSmallStartAt:
                Math.floor(moment(this.dateSelect.state.endDate, 'YYYY-MM-DDTHH:mm:ss').valueOf() / 1000) <=
                Math.floor(moment(this.dateSelect.state.startDate, 'YYYY-MM-DDTHH:mm:ss').valueOf() / 1000),
            noImageUploaded: !this.state.imageData.CHS || !this.state.imageData.ENU,
        }

        const errorList = []
        Object.entries(verifyRule).forEach(([key, item]) => {
            if (item) {
                if (key === 'noImageUploaded') {
                    ['CHS', 'ENU'].forEach((imgkey) => {
                        if (this.state.imageData[imgkey] === null) addToast(utils.t(key, 'ActivityImageDialog', { currency: utils.t('Language.' + imgkey) }), 'error')
                    })
                } else {
                    addToast(utils.t(key, 'ActivityImageDialog'), 'error')
                }
                errorList.push(key)
            }
        })
        return errorList.length === 0 ? true : false
    }

    addActivityImage() {
        if (this.verifyData()) {
            const formData = new FormData()
            Object.entries(this.state.imageData).forEach(([key, item]) => {
                formData.append(key, item)
            })
            formData.append('type', this.state.imgType === 'bannerImg' ? 1 : 2)
            formData.append('is_custom', this.state.is_custom)
            formData.append('name', this.state.name)
            formData.append('is_active', this.state.is_active === 'active')
            formData.append('start_at', moment(this.dateSelect.state.startDate).utcOffset(0).add('12', 'hours').unix())
            formData.append('end_at', moment(this.dateSelect.state.endDate).utcOffset(0).add('12', 'hours').unix())
            if (this.state.is_custom) {
                formData.append('pf_id', this.pfSubPfSelect.state.pfId)
                for (var i in this.state.pfSubPfIDList) {
                    formData.append(`pf_sub_pf_list[]`, this.state.pfSubPfIDList[i])
                }
            }
            utils.apiRequest(
                'post',
                API.ACTIVITY_IMAGES,
                formData,
                (_data) => {
                    if (this.props.confirmCallback) {
                        this.props.confirmCallback()
                    }
                    this.closeDialog()
                },
                (_err) => { },
                false,
                'multipart/form-data'
            )
        }
    }

    async verifyType(file) {
        return new Promise((reslove) => {
            const typeRole = this.state.typeRole[this.state.imgType]
            const image = new Image()
            image.src = file.src

            image.onload = () => {
                file.width = image.width
                file.height = image.height
                if (
                    !typeRole.format.includes(file.type.replace('image/', '')) ||
                    file.size / 1024 > typeRole.size ||
                    file.width > typeRole.width ||
                    file.height > typeRole.height
                ) {
                    return reslove(false)
                }
                return reslove(true)
            }
            image.onerror = () => {
                return reslove(false)
            }
        })
    }

    uploadImage(key) {
        const fileInput = document.getElementById(`fileInput-${key}`)
        const file = fileInput.files[0]

        let imgReader
        if (file) {
            imgReader = new FileReader()
            imgReader.readAsDataURL(file)
            imgReader.onload = async (event) => {
                file.src = event.target.result
                const verifyResult = await this.verifyType(file)
                if (!verifyResult) {
                    addToast(utils.t('typeError', 'ActivityImageDialog'), 'error')
                    return
                }

                this.setState({
                    imageData: {
                        ...this.state.imageData,
                        [key]: file,
                    },
                })
            }
        }
    }

    render() {
        return (
            <Dialog fullWidth maxWidth="md" open={this.state.dialogOpen} onClose={() => this.setState({ dialogOpen: false })}>
                <DialogTitle>{this.state.title}</DialogTitle>
                <DialogContent className={this.props.classes.dialogContent}>
                    <Grid container spacing={2}>
                        <Grid item xs={5}>
                            <Grid>
                                <FormControl className={this.props.classes.formControl}>
                                    <InputLabel>{utils.t('imgType', 'ActivityImageManagePage')}</InputLabel>
                                    <Select
                                        value={this.state.imgType}
                                        onChange={(event) => {
                                            this.setState({
                                                imgType: event.target.value,
                                            })
                                        }}>
                                        {['bannerImg', 'iconImg'].map((item) => (
                                            <MenuItem value={item} key={item}>
                                                {utils.t(item, 'ActivityImageManagePage')}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid className={this.props.classes.formControl}>
                                <TextField
                                    label={utils.t('imgName', 'ActivityImageManagePage')}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    value={this.state.name}
                                    onChange={(event) => {
                                        this.setState({
                                            name: event.target.value,
                                        })
                                    }}
                                    variant="standard"
                                    placeholder={this.t('enterActivityImageName')}
                                    type="text"
                                />
                            </Grid>
                            <Grid item className={this.props.classes.specifyRadio}>
                                <FormControlLabel
                                    checked={!this.state.is_custom}
                                    onChange={() => {
                                        this.setState({
                                            is_custom: false,
                                        })
                                    }}
                                    control={<Radio color="primary" />}
                                    label={this.t('notCustom')}
                                />
                                <FormControlLabel
                                    checked={this.state.is_custom}
                                    onChange={() => {
                                        this.setState({
                                            is_custom: true,
                                        })
                                    }}
                                    control={<Radio color="primary" />}
                                    label={this.t('isCustom')}
                                />
                            </Grid>
                            {this.state.is_custom && (
                                <Grid item container>
                                    <Grid item className={this.props.classes.gridAlignment}>
                                        <PfSubPfSelect
                                            onRef={(ref) => (this.pfSubPfSelect = ref)}
                                            options={{
                                                pfChangeCallback: () => {
                                                    this.setState({ pf_id: this.pfSubPfSelect.state.pfId }, async () => {
                                                        this.setSelectPf()
                                                    })
                                                },
                                                hideAutocomplete: true,
                                                hideAllPlatform: true,
                                            }}
                                        />
                                    </Grid>
                                    <Grid item className={this.props.classes.treeSelect}>
                                        <FormControl>
                                            <FormLabel className={this.props.classes.shrink}>{this.t('pfSubPf')}</FormLabel>
                                            <TreeSelect
                                                treeData={this.state.pfSubTree}
                                                value={this.state.pfSubPfIDList}
                                                onChange={(value) => {
                                                    this.setState({
                                                        pfSubPfIDList: value,
                                                    })
                                                }}
                                                maxTagCount={1}
                                                treeCheckable={true}
                                                showCheckedStrategy={TreeSelect.SHOW_CHILD}
                                                searchPlaceholder={this.t('pleaseSelect')}
                                                dropdownStyle={{ zIndex: 3000 }}
                                            />
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            )}
                            <Grid item className={this.props.classes.gridAlignment}>
                                <DatetimeSelect
                                    startDateMinDate={utils.datetimeStartOfWithoutOffset(utils.currentDatetime(), 'day')}
                                    endMaxDate={moment().add(10, 'y').endOf('y').format('yyyy-MM-DD')}
                                    startMaxDate={moment().add(10, 'y').endOf('y').format('yyyy-MM-DD')}
                                    label={{
                                        start: this.t('start_at'),
                                        end: this.t('end_at'),
                                    }}
                                    onRef={(ref) => (this.dateSelect = ref)}
                                />
                            </Grid>
                            <Grid>
                                <FormControl className={this.props.classes.formControl}>
                                    <InputLabel>{this.t('isActive')}</InputLabel>
                                    <Select
                                        value={this.state.is_active}
                                        onChange={(event) => {
                                            this.setState({
                                                is_active: event.target.value,
                                            })
                                        }}>
                                        {['active', 'close'].map((item) => (
                                            <MenuItem value={item} key={item}>
                                                {this.t(item)}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>
                        <Grid container item xs={7} spacing={2}>
                            <Grid item xs={12}>
                                上傳圖片
                            </Grid>
                            {Object.keys(this.state.imageData).map((key) => {
                                const data = this.state.imageData[key]
                                return (
                                    <Grid item xs={6} key={key}>
                                        <div className={this.props.classes.language}>{utils.t('Language.' + key)}</div>
                                        <input
                                            accept="image/*"
                                            style={{ display: 'none' }}
                                            id={`fileInput-${key}`}
                                            type="file"
                                            onChange={() => {
                                                this.uploadImage(key)
                                            }}
                                        />
                                        <label className={this.props.classes.imageContainer} htmlFor={`fileInput-${key}`}>
                                            {data ? (
                                                <img
                                                    src={data.src}
                                                    alt={`img-${key}`}
                                                    id={`img-${key}`}
                                                    className={this.props.classes.imageContainer}
                                                />
                                            ) : (
                                                <div>{this.t('previewUploadedImg')}</div>
                                            )}
                                        </label>
                                    </Grid>
                                )
                            })}
                        </Grid>
                    </Grid>
                </DialogContent>
                <Divider />
                <DialogActions>
                    <div className={this.props.classes.dialogActions}>
                        <div className={this.props.classes.hintText}>
                            {utils.t('hintText', 'ActivityImageDialog', {
                                width: this.state.typeRole[this.state.imgType].width,
                                height: this.state.typeRole[this.state.imgType].height,
                                size: this.state.typeRole[this.state.imgType].size,
                                format: this.state.typeRole[this.state.imgType].format.join().replace(',', ' 或 '),
                            })}
                        </div>
                        <div>
                            <Button variant="contained" onClick={() => this.addActivityImage()} color="primary">
                                {this.t('confirm')}
                            </Button>
                            <Button className={this.props.classes.cancelBtn} variant="contained" onClick={() => this.closeDialog()} color="secondary">
                                {this.t('cancel')}
                            </Button>
                        </div>
                    </div>
                </DialogActions>
            </Dialog>
        )
    }
}

const styles = (_theme) => {
    return {
        formControl: {
            marginTop: '30px',
            width: '150px',
        },
        dialogContent: {
            height: '640px',
        },
        imageContainer: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '145px',
            width: '100%',
            borderWidth: '0.5px',
            borderColor: 'black',
            borderStyle: 'solid',
            borderRadius: '5px',
            cursor: 'pointer',
        },
        language: {
            paddingBottom: '2px',
        },
        shrink: {
            transform: 'translate(0, 1.5px) scale(0.75)',
            transformOrigin: 'top left',
            marginBottom: '0',
            paddingLeft: '24px',
        },
        gridAlignment: {
            margin: '-8px',
            marginTop: '20px',
        },
        treeSelect: {
            width: '200px',
            paddingLeft: '20px',
            marginTop: '30px',
        },
        specifyRadio: {
            marginTop: '20px',
            marginBottom: '-20px',
        },
        cancelBtn: {
            marginLeft: '8px',
        },
        hintText: {
            color: 'red',
        },
        dialogActions: {
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            alignItems: 'center',
        },
    }
}

AddActivityImageDialog.propTypes = {
    classes: PropTypes.object.isRequired,
    onRef: PropTypes.func,
    confirmCallback: PropTypes.func,
}

export default hoc(styles)(AddActivityImageDialog)
